import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "../store";
import graphClient from "../../../../utils/graphql/graph_client";
import { GetTrail } from "../../../../utils/graphql/trail-graph";
import {bbox as turfBbox, distance as turfDistance} from "@turf/turf";
import {GridRefUtils} from "../../../../utils/helpers/GridRefPreference";
import {MeasurementPrefUtility} from "../../../../utils/helpers/MeasurementPref";
import * as turf from '@turf/turf';
import {HiikerColor} from "../../../../utils/helpers/HiikerColor";
import mapboxgl from "mapbox-gl";
import { appCheck, getToken } from "../../../../utils/firebase/appCheck";


export class AmenityAppState {
  trailId: number | null = null
  center: mapboxgl.LngLatLike = [0,0]
  zoom: number = 13
  trail: any = null
  loading: boolean = false
  mapInitialised: boolean = false
  miniCoordsBar: string = ''
  mapBoundsSet: boolean = false
  regionSlug: string | null = null
  trailSlug: string | null = null
  countrySlug: string | null = null
}

let markers: any = []

const actions: ActionTree<AmenityAppState, RootState> = {
  async initialiseStore(store) {
    store.commit('setSlugData')
    store.commit('setCenter', [parseFloat(window.trailCenterX), parseFloat(window.trailCenterY)])
    // @ts-ignore
    store.commit('setTrailId', window.trail_id)
    await store.dispatch('getTrail')
  },
  mapInitialised(store) {
    store.commit('setMapInitialised', true)
    const gridRef = GridRefUtils.preference()
    window.map.addControl(
      new mapboxgl.NavigationControl({ showCompass: true, showZoom: true, visualizePitch: true }),
      'bottom-left'
    );
    let measurementPreference = MeasurementPrefUtility.preference()
    // @ts-ignore
    window.map.addControl(new mapboxgl.ScaleControl({ unit: measurementPreference.mapbox(), maxWidth: 150 }), 'bottom-left');
  },
  async getTrail(store) {
    try {
      let headers = {};
      try {
        const appCheckTokenResponse = await getToken(appCheck, false)
        headers = { 'X-Firebase-AppCheck': appCheckTokenResponse.token }
      } catch (e) {
        console.error(e);
      }
      let trailRequest = await graphClient.request(GetTrail,
        {id: store.state.trailId}, headers,
      )
      store.commit('setTrail', trailRequest.trail)
      await store.dispatch('setTrailOnMap')
    } catch (e) {
      // @ts-ignore
      alert(e.message)
    }
  },
  async setTrailOnMap(store) {
    if (!store.state.mapInitialised) {
      return
    }
    const trail = store.state.trail
    if (trail) {
      store.dispatch('removeTrailFromMap')
      let trailId = 'trail'
      let trailLayer: mapboxgl.LineLayer = {
        id: trailId,
        type: "line",
        source: trailId,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#ff0000",
          "line-width": 5,
        }
      }
      if (window.map.getSource(trailId) == null) {
        window.map.addSource(trailId, {
          type: "geojson",
          // @ts-ignore
          data: store.getters.getTrailGeoJsonFeature,
        })
      }
      window.map.addLayer(trailLayer)
      await store.dispatch('addPolylineArrowLayerToMap')
      if (!store.state.mapBoundsSet) {
        await store.dispatch('setMapBoundsFromPolygonGeoJson')
      }
    }
  },
  removeTrailFromMap(store) {
    if (!store.state.mapInitialised) {
      return
    }
    const map = window.map
    if (map?.getLayer('trail')) {
      map.removeLayer('trail')
    }
    if (map?.getLayer('trail-arrow')) {
      map.removeLayer('trail-arrow')
    }
  },
  setMapBoundsFromPolygonGeoJson(store) {
    const map = window.map
    const newBbox = turfBbox(store.getters.getTrailGeoJsonFeature);
    // @ts-ignore
    const bounds = mapboxgl.LngLatBounds.convert(newBbox);
    map?.fitBounds(bounds, { padding: 100 });
    store.commit('setMapBoundsSet', true)
  },
  setMapBoundsFromTrailBounds(store) {

  },
  addPolylineArrowLayerToMap(
    store,
  ) {
    const arrowLayer = 'trail-arrow'
    const targetLayer = 'trail'
    const url = "https://i.postimg.cc/3JMHRKJ3/polyline-arrow-symbol.png";
    window.map.loadImage(url, (error?: Error | undefined, result?: HTMLImageElement | ImageBitmap | undefined) => {
      if (error || window.map.getSource(targetLayer) == null) {
        return;
      }
      if (window.map.hasImage(arrowLayer)) {
        window.map.removeImage(arrowLayer);
      }
      window.map.addImage(arrowLayer, result as ImageBitmap);
      if (window.map.getLayer(arrowLayer)) {
        window.map.removeLayer(arrowLayer);
      }
      window.map.addLayer({
        id: arrowLayer,
        type: "symbol",
        source: targetLayer,
        layout: {
          "symbol-placement": "line",
          "icon-allow-overlap": true,
          'icon-ignore-placement': true,
          "icon-image": arrowLayer,
          "icon-size": 0.045,
          visibility: "visible",
        },
      });
    });
  },
}

const mutations: MutationTree<AmenityAppState> = {
  setTrailId(state, trailId: number) {
    state.trailId = trailId
  },
  setTrail(state, trail: any) {
    state.trail = trail
  },
  setMapInitialised(state, mapInitialised: boolean) {
    state.mapInitialised = mapInitialised
  },
  setCenter(state, center: mapboxgl.LngLatLike) {
    state.center = center
  },
  setMapBoundsSet(state, mapBoundsSet: boolean) {
    state.mapBoundsSet = mapBoundsSet
  },
  setSlugData(state) {
    state.trailSlug = window.slug;
    state.regionSlug = window.region_slug;
    state.countrySlug = window.country_slug;
    state.trailId = window.id
  },
}

// @ts-ignore
const getters: GetterTree<AmenityAppState, RootState> = {
  // @ts-ignore
  getTrailLayer(): mapboxgl.LineStyleLayer {
    return {
      id: 'trail',
      type: "line",
      source: 'trail',
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": HiikerColor.red,
        "line-width": 5,
      }
    }
  },
  getTrailGeoJsonFeature(state) {
    return JSON.parse(state.trail.lineString.geoData).features[0]
  },
  getLineString(state, getters) {
    return turf.lineString(getters.getTrailGeoJsonFeature.geometry.coordinates)
  },
  trailUrl(state) {
    return `/trails/${state.countrySlug}/${state.regionSlug}/${state.trailSlug}`;
  },
}

const state = new AmenityAppState();

export default class AmenityAppModule implements Module<AmenityAppState, RootState> {
  namespaced = true
  state = state
  actions = actions
  mutations = mutations
  getters = getters
}
